import { h } from "@stencil/core";
import { RenderInfo } from "./RenderInfo";
import { toEmptyFileList, toFileList, toString, toArray } from "./utils";
import { hasInputOptionValue } from "./FormDefinition";
function renderValidationResult(validationResult, serverSideError) {
    return [
        ((validationResult.valid && undefined === serverSideError['']) ? h("div", { style: { width: "5%", color: 'green' } }, "\u2705") : h("div", { style: { width: "5%", color: 'red' } }, "\u274C")),
        (Object.keys(serverSideError).length > 0 && h("div", { style: { width: "100%", color: 'red', fontWeight: 'bold', padding: '10px', backgroundColor: '#fdd' } }, Object.entries(serverSideError).map((v) => toString(v[1])))),
        (validationResult.messages.filter((r) => !r.valid || !r.serverSide)
            .map((r) => {
            return h("div", { style: { width: "100%" } }, h("span", null, r.message), r.valid ? h("span", { style: { color: 'green' } }, "\u2705") : h("span", { style: { color: 'red' } }, "\u274C"));
        }))
    ];
}
function renderFieldRow(content, input, fieldWrapOptions = {}) {
    const canEnterEmptyString = fieldWrapOptions.canEnterEmptyString !== false;
    const hasValidationErrors = fieldWrapOptions.canShowClientsideValidationErrors !== false
        || fieldWrapOptions.canShowServersideValidationErrors !== false;
    return h("div", { style: { width: '100%', display: 'flex', flexWrap: 'wrap', alignItems: 'left', justifyContent: 'left' } }, h("div", { style: { width: '5%' } }, input.allowsNull && (!canEnterEmptyString || input.emptyStringAllowed) && h("input", { disabled: input.disabled, type: "checkbox", checked: input.value !== null, onClick: (ev) => {
            input.onTouched();
            if (!ev.target.checked) {
                input.valueChanged(null);
            }
            else {
                input.valueChanged('');
            }
        } })), h("div", { style: { width: '90%' } }, content), hasValidationErrors && renderValidationResult(input.validationResult, fieldWrapOptions.canShowServersideValidationErrors !== false ? input.serverValidationError : {}));
}
export class FallbackRenderInfo extends RenderInfo {
    constructor() {
        super(null);
        this.singleInputRenderers = {
            text(state) {
                const disabled = state.disabled || (state.allowsNull && state.emptyStringAllowed && state.value === null);
                return state.currentFieldWrapper([
                    h("input", { type: "text", disabled: disabled, onBlur: () => state.onTouched(), onInput: (ev) => { var _a; return state.valueChanged((_a = ev.target) === null || _a === void 0 ? void 0 : _a.value); }, name: state.name, value: toString(state.value) }),
                    (state.label && h("label", { htmlFor: state.name }, state.label)),
                ], state);
            },
            combobox(state) {
                const disabled = state.disabled || (state.allowsNull && state.emptyStringAllowed && state.value === null);
                return state.currentFieldWrapper([
                    h("apie-combobox-input", { name: state.name, label: state.label, disabled: disabled, value: toString(state.internalState), selectedValues: state.value ? [toString(state.value)] : [], options: state.additionalSettings.autocompleteUrl ? null : state.additionalSettings.options.map((v) => {
                            return { displayValue: v.name, value: v.value };
                        }), removeDisabled: true, touched: state.touched, autocompleteUrl: state.additionalSettings.autocompleteUrl, renderInfo: state.renderInfo, onValueChanged: (ev) => state.internalStateChanged(ev), onFieldTouched: () => state.onTouched(), onOptionClicked: (ev) => state.valueChanged(ev.detail.value), onSelectedValueChanged: (ev) => { var _a; return state.valueChanged((_a = ev.detail[0]) !== null && _a !== void 0 ? _a : null); } }),
                ], state);
            },
            comboboxtext(state) {
                return [
                    h("input", { type: "text", disabled: state.disabled, onBlur: () => state.onTouched(), onInput: (ev) => { var _a; return state.valueChanged((_a = ev.target) === null || _a === void 0 ? void 0 : _a.value); }, name: state.name, value: toString(state.value) }),
                    (state.label && h("label", { htmlFor: state.name }, state.label)),
                ];
            },
            number(state) {
                const disabled = state.disabled || (state.allowsNull && state.emptyStringAllowed && state.value === null);
                return state.currentFieldWrapper([
                    h("input", { type: "number", disabled: disabled, onBlur: () => state.onTouched(), onInput: (ev) => { var _a; return state.valueChanged((_a = ev.target) === null || _a === void 0 ? void 0 : _a.value); }, name: state.name, value: toString(state.value) }),
                    (state.label && h("label", { htmlFor: state.name }, state.label)),
                ], state);
            },
            integer(state) {
                const disabled = state.disabled || (state.allowsNull && state.emptyStringAllowed && state.value === null);
                return state.currentFieldWrapper([
                    h("input", { type: "number", step: "1", onBlur: () => state.onTouched(), disabled: disabled, onInput: (ev) => { var _a; return state.valueChanged((_a = ev.target) === null || _a === void 0 ? void 0 : _a.value); }, name: state.name, value: toString(state.value) }),
                    (state.label && h("label", { htmlFor: state.name }, state.label)),
                ], state);
            },
            datetime(state) {
                var _a;
                const disabled = state.disabled || (state.allowsNull && state.emptyStringAllowed && state.value === null);
                return state.currentFieldWrapper([
                    h("apie-php-date-input", { renderInfo: state.renderInfo, onBlur: () => state.onTouched(), disabled: disabled, onChange: (ev) => { var _a; return state.valueChanged((_a = ev.target) === null || _a === void 0 ? void 0 : _a.value); }, name: state.name, value: toString(state.value), dateFormat: (_a = state.additionalSettings.dateFormat) !== null && _a !== void 0 ? _a : 'Y-m-d\\TH:i' }),
                    (state.label && h("label", { htmlFor: state.name }, state.label)),
                ], state, {
                    canEnterEmptyString: false
                });
            },
            password(state) {
                const disabled = state.disabled || (state.allowsNull && state.emptyStringAllowed && state.value === null);
                return state.currentFieldWrapper([
                    h("input", { type: "password", disabled: disabled, onBlur: () => state.onTouched(), onInput: (ev) => { var _a; return state.valueChanged((_a = ev.target) === null || _a === void 0 ? void 0 : _a.value); }, name: state.name, value: toString(state.value) }),
                    (state.label && h("label", { htmlFor: state.name }, state.label)),
                ], state);
            },
            textarea(state) {
                const disabled = state.disabled || (state.allowsNull && state.emptyStringAllowed && state.value === null);
                const rows = Math.max(2, String(state.value).split("\n").length + 1);
                return state.currentFieldWrapper([
                    h("textarea", { disabled: disabled, onBlur: () => state.onTouched(), onInput: (ev) => { var _a; return state.valueChanged((_a = ev.target) === null || _a === void 0 ? void 0 : _a.value); }, name: state.name, rows: rows }, toString(state.value)),
                    (state.label && h("label", { htmlFor: state.name }, state.label)),
                ], state);
            },
            hidden(state) {
                if (state.additionalSettings.forcedValue !== undefined && state.value !== state.additionalSettings.forcedValue) {
                    Promise.resolve().then(() => state.valueChanged(state.additionalSettings.forcedValue));
                }
                if (!state.validationResult.valid) {
                    return renderValidationResult(state.validationResult, state.serverValidationError);
                }
                return [];
            },
            file(state) {
                return (h("div", null, h("input", { type: "file", disabled: state.disabled, onInput: (ev) => { var _a; return state.valueChanged((_a = ev.target) === null || _a === void 0 ? void 0 : _a.files[0]); }, name: state.name, files: state.value ? toFileList(state.value) : toEmptyFileList() }), state.value && h("input", { type: "button", onClick: () => { state.valueChanged(null); state.onTouched(); }, value: "remove" }), state.label && h("label", { htmlFor: state.name }, state.label), ",", renderValidationResult(state.validationResult, state.serverValidationError)));
            },
            html(state) {
                const style = `
            .html-field {
              padding: 10px;
              border: 1px solid #ccc;
              border-radius: 5px;
              min-height: 200px;
              font-family: Arial, sans-serif;
              font-size: 14px;
              line-height: 1.5;
          }
            
          .html-field:empty:before {
              content: attr(placeholder);
              color: #999;
          }
            
          .html-field:focus {
              border-color: #007bff;
              outline: none;
              box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.2);
          }
            
          .html-field::selection {
              background-color: #007bff;
              color: #fff;
          }
            
          .html-field::-webkit-scrollbar {
              width: 8px;
          }
            
          .html-field::-webkit-scrollbar-thumb {
              background-color: #ccc;
              border-radius: 4px;
          }
            
          .html-field::-webkit-scrollbar-thumb:hover {
              background-color: #aaa;
          }
          .html-field.disabled {
            background-color: #f8f9fa; /* Light gray to indicate disabled */
            color: #6c757d; /* Muted text color */
            border-color: #e0e0e0;
            pointer-events: none; /* Prevent interaction */
        }
`;
                const disabled = state.disabled || (state.allowsNull && state.emptyStringAllowed && state.value === null);
                return state.currentFieldWrapper(h("div", { style: { margin: "5px", padding: "5px" } }, h("style", null, style), h("article", { contenteditable: !disabled, class: `html-field unhandled${disabled ? ' disabled' : ''}`, onBlur: () => state.onTouched(), onInput: (ev) => { var _a; return state.valueChanged((_a = ev.target) === null || _a === void 0 ? void 0 : _a.innerHTML); }, innerHTML: toString(state.value) }), h("textarea", { style: { display: 'none' }, name: state.name, class: "unhandled-editor" }, state.value), h("label", { htmlFor: state.label }, state.label)), state);
            },
            select(state) {
                var _a;
                if (!Array.isArray((_a = state.additionalSettings) === null || _a === void 0 ? void 0 : _a.options)) {
                    return state.currentFieldWrapper([
                        h("select", { disabled: true }, h("option", { selected: true }, state.value)),
                        renderValidationResult(state.validationResult, state.serverValidationError)
                    ], state, {
                        canEnterEmptyString: false
                    });
                }
                const nullIsOption = hasInputOptionValue(state, null);
                const disabled = state.disabled || (!nullIsOption && state.value === null);
                return state.currentFieldWrapper([
                    h("select", { disabled: disabled, onBlur: () => state.onTouched(), onChange: (ev) => state.valueChanged(ev.target.value) }, !hasInputOptionValue(state, state.value) && h("option", { key: toString(state.value), value: toString(state.value), selected: true }, state.value), state.additionalSettings.options.map((opt) => h("option", { key: toString(opt.value), value: toString(opt.value), selected: state.value === opt.value }, opt.name))),
                ], state, {
                    canEnterEmptyString: !nullIsOption
                });
            },
            multi(state) {
                var _a;
                const value = new Set(toArray(state.value));
                if (!Array.isArray((_a = state.additionalSettings) === null || _a === void 0 ? void 0 : _a.options)) {
                    return state.currentFieldWrapper([
                        h("select", { multiple: true, disabled: true }, h("option", { selected: true }, toString(value))),
                        renderValidationResult(state.validationResult, state.serverValidationError)
                    ], state, {
                        canEnterEmptyString: false
                    });
                }
                const disabled = state.disabled || (state.allowsNull && state.value === null);
                return state.currentFieldWrapper([
                    h("select", { multiple: true, disabled: disabled, onBlur: () => state.onTouched(), onChange: (ev) => state.valueChanged(Array.from(ev.target.selectedOptions).map((option) => option.value)) }, state.additionalSettings.options.map((opt) => h("option", { value: toString(opt.value), selected: value.has(opt.value) }, opt.name))),
                    renderValidationResult(state.validationResult, state.serverValidationError)
                ], state, {
                    canEnterEmptyString: false
                });
            },
            "null"(state) {
                const showValidationError = !state.validationResult.valid && state.validationResult.messages.length > 0;
                if (state.value !== null && !state.disabled) {
                    Promise.resolve().then(() => {
                        state.valueChanged(null);
                    });
                }
                return showValidationError
                    ? renderValidationResult(state.validationResult, state.serverValidationError)
                    : h("div", { style: { display: 'none' } });
            }
        };
    }
    ;
    createFieldWrapper() {
        return renderFieldRow;
    }
}
//# sourceMappingURL=FallbackRenderInfo.js.map
